import { render, staticRenderFns } from "./tzddtgzMb.vue?vue&type=template&id=24805c5a&scoped=true&"
import script from "./tzddtgzMb.vue?vue&type=script&lang=js&"
export * from "./tzddtgzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24805c5a",
  null
  
)

export default component.exports